import { render, staticRenderFns } from "./GeneralCoupons.vue?vue&type=template&id=f098916a&scoped=true"
import script from "./GeneralCoupons.vue?vue&type=script&lang=js"
export * from "./GeneralCoupons.vue?vue&type=script&lang=js"
import style0 from "./GeneralCoupons.vue?vue&type=style&index=0&id=f098916a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f098916a",
  null
  
)

export default component.exports